var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap align-center mb-3"
            },
            [
              _c(
                "h2",
                {
                  staticClass: "body-1 mr-auto kvm-card-title"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pb-1",
                      attrs: {
                        size: "24",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-docker")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ml-2"
                    },
                    [_vm._v("Docker")]
                  ),
                  _vm.status && _vm.status.available
                    ? _c(
                        "span",
                        {
                          staticClass: "kvm-help text-caption ml-2"
                        },
                        [
                          _vm._v(" Engine " + _vm._s(_vm.status.version)),
                          _vm.status.compose_version
                            ? [
                                _vm._v(
                                  " · Compose " +
                                    _vm._s(_vm.status.compose_version)
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm.appInstall &&
          ["pending", "installing"].includes(_vm.appInstall.state)
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3 kvm-dk-alert",
                  attrs: {
                    type: "info",
                    dense: "",
                    text: "",
                    role: "status"
                  }
                },
                [
                  _vm._v(
                    " Installing " +
                      _vm._s(_vm.appInstall.name) +
                      "… it was chosen with this server and is installed automatically once the server is ready. "
                  )
                ]
              )
            : _vm.appInstall && _vm.appInstall.state === "failed"
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3 kvm-dk-alert",
                  attrs: {
                    type: "warning",
                    dense: "",
                    text: ""
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.appInstall.error ||
                          "".concat(
                            _vm.appInstall.name,
                            " couldn't be installed."
                          )
                      ) +
                      " You can deploy it again under Apps. "
                  )
                ]
              )
            : _vm._e(),
          !_vm.server.docker_enabled
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: {
                    type: "info",
                    border: "left",
                    dense: ""
                  }
                },
                [_vm._v(" Docker management isn't available for this server. ")]
              )
            : _vm.server.power_state && _vm.server.power_state !== "online"
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: {
                    type: "info",
                    border: "left",
                    dense: ""
                  }
                },
                [
                  _vm._v(
                    " This server is " +
                      _vm._s(_vm.server.power_state) +
                      ". Power it on to manage Docker. "
                  )
                ]
              )
            : [
                _vm.checking
                  ? _c(
                      "div",
                      {
                        staticClass: "py-8 text-center",
                        attrs: {
                          role: "status",
                          "aria-live": "polite"
                        }
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "primary",
                            size: "36",
                            width: "3"
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "kvm-sr-only"
                          },
                          [_vm._v("Checking Docker…")]
                        )
                      ],
                      1
                    )
                  : !_vm.status || !_vm.status.available
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          type: "warning",
                          border: "left",
                          dense: "",
                          role: "alert"
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.unavailableText) + " "),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2"
                          },
                          [
                            _c(
                              "gg-btn",
                              {
                                attrs: {
                                  small: "",
                                  tile: "",
                                  outlined: "",
                                  color: "primary"
                                },
                                on: {
                                  click: _vm.check
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      left: "",
                                      small: "",
                                      "aria-hidden": "true"
                                    }
                                  },
                                  [_vm._v("mdi-refresh")]
                                ),
                                _vm._v("Check again ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : [
                      _vm._l(_vm.operations, function(op) {
                        return _c("kvm-docker-operation", {
                          key: op.id,
                          attrs: {
                            "service-id": _vm.server.id,
                            operation: op
                          },
                          on: {
                            done: _vm.onOperationDone,
                            dismiss: function dismiss($event) {
                              return _vm.dismiss(op)
                            }
                          }
                        })
                      }),
                      _c(
                        "v-tabs",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            "show-arrows": ""
                          },
                          model: {
                            value: _vm.tab,
                            callback: function callback($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("v-tab", [_vm._v("Apps")]),
                          _c("v-tab", [_vm._v("Containers")]),
                          _c("v-tab", [_vm._v("Domains")])
                        ],
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function callback($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c("kvm-docker-stacks", {
                                attrs: {
                                  "service-id": _vm.server.id,
                                  "refresh-key": _vm.refreshKey,
                                  "finished-ops": _vm.finishedOps
                                },
                                on: {
                                  operation: _vm.addOperation
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c("kvm-docker-containers", {
                                attrs: {
                                  "service-id": _vm.server.id,
                                  "refresh-key": _vm.refreshKey
                                },
                                on: {
                                  operation: _vm.addOperation
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c("kvm-docker-proxy", {
                                attrs: {
                                  "service-id": _vm.server.id,
                                  "refresh-key": _vm.refreshKey
                                },
                                on: {
                                  operation: _vm.addOperation
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }